module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"omitted_count":"及其他 {0} 件商品","write_review":"前往撰寫評論"}}')
  delete Component.options._Ctor
}
